export enum LayerStatus {
    OPEN = 'open',
    CONFIRMING = 'confirming',
    CLOSING = 'closing',
}
